// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { colors } from '@lmc/common/constants'
import { fade } from '../../../LEGACY/colorUtils'
import { ProfileBadge } from '../ProfileBadge'

const Badge = ({ color, label }) => (
  <div style={styles.badgeContainer}>
    <ProfileBadge
      backgroundColor={color}
      textColor={colors.black}
      badgeText={label}
      badgeStyle={styles.badgeStyle}
    />
  </div>
)

const formatDate = (d) => (d ? dayjs(d).format('DD-MM-YYYY') : '')

const FamilyStatusBadge = ({ contact, residentName, hideWarning }) => {
  const {
    email,
    familyHasAccess,
    familyDateActivated,
    familyComment,
    familyCommentDate,
    familyDateInactivated,
    familyDateInvited,
  } = contact

  let label
  let color
  if (familyHasAccess) {
    if (familyDateActivated) {
      // Family user is active: invited, active and accepted
      label = `Active since ${formatDate(familyDateActivated)}`
      color = fade(colors.successgreen, 20)
    } else if (familyDateInvited) {
      // notAccepted: invited & active but not yet accepted
      label = `Sent invite on ${formatDate(familyDateInvited)}`
      color = colors.grey
    }
  } else if (familyDateInactivated) {
      // Deactivated: invited but the account has deactivated for some reason (eg. not paying)
      label = `Inactive since ${formatDate(familyDateInactivated)}`
      color = fade(colors.red, 20)
    } else if (familyComment && !familyHasAccess) {
      // explicitly not invited, with a comment explaining why
      label = `Not invited on ${formatDate(familyCommentDate)}`
      color = colors.grey
    }

  if (label) {
    return (
      <div style={styles.container}>
        <Badge label={label} color={color} />
      </div>
    )
  }

  const REMINDER_TEXT = `Before creating the invitation,
        please ensure that the correct permissions have been obtained
        for this person to have access to ${
          residentName ? `${residentName  }'s` : 'this'
        } information.`

  if (email && !familyComment && !hideWarning) {
    return <div style={styles.reminderContainer}>{REMINDER_TEXT}</div>
  }

  return null
}

FamilyStatusBadge.propTypes = {
  contact: PropTypes.object.isRequired,
}

const styles = {
  container: {
    marginTop: 8,
    marginBottom: 8,
    color: colors.black,
  },
  reminderContainer: {
    marginTop: 8,
    marginBottom: 8,
    color: colors.black,
  },
  badgeContainer: {
    marginBottom: 4,
    display: 'flex',
  },
  badgeStyle: {
    padding: '3px 9px',
    fontSize: 12,
  },
}

export default FamilyStatusBadge
